import React from 'react';
import { connect } from 'react-redux';
import { withAccordion, PriceInputContainer } from '../../components/shared';
import { commifyNumber } from '../../utils/utilities';
import BaseCoverage from './BaseCoverage';
import classNames from 'classnames';

import './coverage-selector.scss';

class CoverageSelector extends React.Component {
    constructor(props) {
        super(props);
        const {
            pricingValues,
            value,
            basePremium,
            defaultCoverageOptions,
            manuallySetPricing = false
        } = props;

        const options = pricingValues.baseCoverageOption
            ? coverageMapper(
                  defaultCoverageOptions,
                  pricingValues.baseCoverageOption,
                  basePremium,
                  value
              )
            : defaultCoverageOptions;
        let schedFct = 1.0;
        if (this.props.pricingValues.scheduleFactor) {
            schedFct = Number.parseFloat(this.props.pricingValues.scheduleFactor);
        } else if (this.props.pricingValues.systemBasePremium) {
            schedFct = this.props.basePremium / this.props.pricingValues.systemBasePremium;
        }
        this.state = {
            options,
            systemBasePrem: this.props.pricingValues.systemBasePremium
                ? this.props.pricingValues.systemBasePremium
                : '',
            scheduleFactor: schedFct
        };
        const requiredOption = options.find(option => option.selected);
        requiredOption.key = 'basePremium';
        props.updatePricingOptions([requiredOption]);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.onBlurTextboxHandler = this.onBlurTextboxHandler.bind(this);
    }

    componentDidUpdate(prevProps) {
        let updateBaseCovgPrems = false;
        const {
            pricingValues,
            value,
            basePremium,
            defaultCoverageOptions,
            manuallySetPricing = false
        } = this.props;
        if (manuallySetPricing) {
            Object.keys(pricingValues.baseCoverageOption).forEach(k => {
                if (
                    (!Number.isNaN(prevProps.pricingValues.baseCoverageOption[k]) &&
                    !Number.isNaN(pricingValues.baseCoverageOption[k])) &&
                    prevProps.pricingValues.baseCoverageOption[k] !==
                    pricingValues.baseCoverageOption[k]
                ) {
                    updateBaseCovgPrems = true;
                }
            });
            if (updateBaseCovgPrems === true) {
                const options = coverageMapper(
                    defaultCoverageOptions,
                    this.props.pricingValues.baseCoverageOption,
                    basePremium,
                    value
                );
                this.setState({
                    options
                });
            }
        }
    }
    handleOnChange(evt, value) {
        const options = this.state.options.map(prevOption => {
            let option = { ...prevOption };
            if (this.props.manuallySetPricing && option.selected) {
                //user is changing Base Coverage so reset currently selected basePremium to systemBasePremium
                option.text = formatPremium(this.props.pricingValues.systemBasePremium);
            }
            if (option.value === value) {
                option.selected = true;
                option.key = 'basePremium';
            } else {
                option.selected = false;
            }
            return option;
        });

        this.setState({ options }, () => {
            const requiredOption = this.state.options.find(option => option.selected);
            this.props.updatePricingOptions([requiredOption]);
        });
        value && this.props.onChange(evt, value);
    }

    onBlurTextboxHandler(priceValue, modifiedCreditDebit = [], scheduleFactor, manualRate) {
        const key = Object.keys(priceValue)[0];
        const options = this.state.options.map(option => {
            if (option.selected && option.value === key) {
                const price = formatPremium(priceValue[key]);
                return {
                    ...option,
                    text: price
                };
            }
            return option;
        });
        this.setState({ options });

        this.setState(
            {
                // modifiedPremium,
                modifiedCreditDebit
            },
            () => {
                this.props.onBlurHandler({ 
                    basePremium: priceValue[key],
                    scheduleFactor: scheduleFactor ? scheduleFactor : null,
                    manualRate: manualRate ? manualRate : null
                });
            }
        );
    }

    render() {
        const {
            value,
            isModified,
            manuallySetPricing,
            pricingValues,
            basePremium,
            accordionArray,
            defaultCoverageOptions,
            rating,
            submission
        } = this.props;

        /**
         * Putting classes in variables so column sizing for the title row
         * and premium rows can be set in one place.
         */
        const baseCovgColumnClasses = manuallySetPricing ? 'col-lg-5 col-md-4 col-sm-5 col-xs-12' : 'col-sm-7 col-xs-12';
        const rateColumnClasses = 'col-lg-2 col-md-3 col-sm-2 col-xs-10';
        const premiumColumnClasses = 'col-lg-4 col-md-4 col-sm-4 col-xs-10';

        let baseCoverageOption = pricingValues.baseCoverageOption;

        let ratedPrem =
            !!rating && !!rating.options
                ? coverageFinder(
                      defaultCoverageOptions,
                      rating.options.baseCoverageOption,
                      rating.options.basePremium,
                      value
                  )
                : coverageFinder(defaultCoverageOptions, baseCoverageOption, basePremium, value);
        let scheduleFactor = '0';
        if (this.props.pricingValues.scheduleFactor) {
            scheduleFactor = this.props.pricingValues.scheduleFactor;
        } else if (this.props.basePremium && this.props.pricingValues.systemBasePremium) {
            scheduleFactor = this.props.basePremium / this.props.pricingValues.systemBasePremium;
        } else if (this.props.basePremium && this.props.submission && this.props.submission.coverages) {
            scheduleFactor = this.props.basePremium /
                this.props.systemRating.options.baseCoverageOption[
                    this.props.submission.coverages.gl.base
                ];
        }

        const modifiedPremium = this.state.options.map(opt => {
            if (opt.selected && opt.value === value) {
                return { [value]: this.props.basePremium ? this.props.basePremium : 0 };
            } else {
                return {
                    [opt.value]: scheduleFactor
                        ? Number.parseFloat((opt.text.replace(/[^0-9.-]+/g, '') * scheduleFactor).toFixed(2))
                        : opt.text.replace(/[^0-9.-]+/g, '')
                };
            }
        });
        if (modifiedPremium && manuallySetPricing && scheduleFactor != 1.0) {
            const modPrem = Object.assign({}, ...modifiedPremium);
            let tempRatedPrem = this.state.options.map(prem => {
                return { [prem.value]: prem.text };
            });
            tempRatedPrem = Object.assign({}, ...tempRatedPrem);
            baseCoverageOption = Object.keys(tempRatedPrem).map(option => {
                if (modPrem.hasOwnProperty(option)) {
                    return { [option]: modPrem[option] };
                } else {
                    return { [option]: tempRatedPrem[option] };
                }
            });

            baseCoverageOption = Object.assign({}, ...baseCoverageOption);
        }
        const updatedOptions = pricingValues.baseCoverageOption
            ? coverageMapper(defaultCoverageOptions, baseCoverageOption, basePremium, value)
            : defaultCoverageOptions;
        const BaseCoveragesAccordion = withAccordion(BaseCoverage, accordionArray);

        return (
            <div
                className={classNames(
                    { row: manuallySetPricing },
                    { basecoveragewidth: manuallySetPricing }
                )}
            >
                <div
                    className={classNames(
                        { 'col-md-8': manuallySetPricing },
                        { 'col-sm-8': manuallySetPricing },
                        'coverageOptionSelectorContainer'
                    )}
                >
                    <div className="row">
                        <div className={baseCovgColumnClasses}>
                            <h4 className="quoteTitle">Base Coverage</h4>
                        </div>
                        {manuallySetPricing && (
                        <>
                            <div className={rateColumnClasses}>
                                <h4 className="quoteTitle">Rate</h4>
                             </div>
                            <div className={premiumColumnClasses}>
                                <h4 className="quoteTitle">Premium</h4>
                            </div>
                        </>
                        )}
                    </div>
                    <BaseCoveragesAccordion
                        name="baseCoverage"
                        options={updatedOptions}
                        value={value}
                        onChange={this.handleOnChange}
                        type="circle"
                        isModified={isModified}
                        manuallySetPricing={manuallySetPricing}
                        onBlurTextboxHandler={this.onBlurTextboxHandler}
                        changePricingValue={this.props.changePricingValue}
                        pricingValues={pricingValues}
                        totalCost={submission.totalCost}
                        columnClasses={{
                            title: baseCovgColumnClasses,
                            rate: rateColumnClasses,
                            premium: premiumColumnClasses
                        }}
                    />
                </div>
                {manuallySetPricing && (
                    <div className="col-md-4 col-sm-4 coverageOptionSelectorContainer">
                        <h4 className="quoteTitle">Credit/Debit</h4>
                        {ratedPrem.map(key => {
                            const ratedPremium =
                                typeof key.text !== 'number'
                                    ? Number(key.text.replace(/[^0-9.-]+/g, ''))
                                    : key.text;
                            return ( key.hideElement !== 'hideElement' &&
                                <div className="credit-debit">
                                    <PriceInputContainer
                                        name="creditDebit"
                                        options={key}
                                        ratedPremium={ratedPremium}
                                        scheduleFactor={scheduleFactor}
                                        onChange={this.handleOnChange}
                                        disable={key.value !== value}
                                        type="circle"
                                        isModified={isModified}
                                        manuallySetPricing={manuallySetPricing}
                                        onBlurTextboxHandler={this.onBlurTextboxHandler}
                                        changePricingValue={this.props.changePricingValue}
                                    />
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        );
    }
}

const formatPremium = amount => {
    const amountWithRounding = amount.toString().indexOf('.') > -1 ? Number.parseFloat(amount.toFixed(2)) : amount;
    return '$' + commifyNumber(amountWithRounding || 0)
}

const coverageMapper = (
    defaultCoverageOptions,
    baseCoverageOption = null,
    defaultBasePremium = 'N/A',
    selectedValue
) => {
    return defaultCoverageOptions.map(({ value, key, ...rest }) => {
        const price =
            baseCoverageOption && baseCoverageOption.hasOwnProperty(value)
                ? baseCoverageOption[value]
                : defaultBasePremium;
        return {
            ...rest,
            value,
            text: price ? formatPremium(price) : '',
            selected: selectedValue === value,
            key
        };
    });
};
const coverageFinder = (
    defaultCoverageOptions,
    baseCoverageOption = null,
    defaultBasePremium = 'N/A',
    selectedValue
) => {
    return defaultCoverageOptions.map(({ value, hideElement = '' }) => {
        const price =
            baseCoverageOption && baseCoverageOption.hasOwnProperty(value)
                ? baseCoverageOption[value]
                : defaultBasePremium;
        return { value, text: price, hideElement };
    });
};

const mapStateToProps = store => {
    return {
        systemRating: store.ratings.items[0]
    };
};

export default connect(mapStateToProps)(CoverageSelector);
